import styled from 'styled-components';

export const LoaderDivStyled = styled.div`
  .img-loader{
    margin: 10% auto;
    width: 40px;
    display: flex;
  }
`;